import { TranslateModule } from '@ngx-translate/core';
import { Component } from '@angular/core';

@Component({
  selector: 'wo-daily-recurrence',
  templateUrl: './daily-recurrence.component.html',
  standalone: true,
  imports: [ TranslateModule ],
})
export class DailyRecurrenceComponent {}
